'use client'

import { cx } from 'class-variance-authority'
import { useTranslations } from 'next-intl'
import { UserCircleIcon } from '@phosphor-icons/react/dist/ssr/UserCircle'
import { Avatar, Button } from '@skop-app/lib-front'
import type { Authorization, Team } from '@skop-app/lib-domain/types'

export const OrganizationSummary = ({
  team,
  handleMemberModal,
  handleOpenSettings,
  authorization,
}: {
  team: Team
  handleMemberModal(member?: { id: string }): void
  handleOpenSettings(): void
  authorization: Authorization | undefined
}) => {
  const t = useTranslations()

  if (!team) return null

  return (
    <div className="block">
      <div className="flex items-center py-4">
        <div className="flex flex-1 items-center">
          <Avatar
            name={team.name}
            picture={team.logo}
            variant="square"
            size="xl"
            className={cx(team.color && `!bg-[${team.color.split(' ')[0]}]`)}
          />
          <div className="ml-4 flex-1 md:grid md:grid-cols-2 md:gap-4">
            <div>
              <p className="truncate text-sm font-medium text-slate-700">
                {team.name}
              </p>
              <p className="mt-2 flex items-center text-sm text-slate-300">
                <UserCircleIcon
                  className="text-slate-430000 mr-1.5 size-5 flex-shrink-0"
                  aria-hidden="true"
                />
                <span className="truncate">
                  {team.members.length} membre(s), créée le{' '}
                  <time dateTime={team.date}>{team.date}</time>
                </span>
              </p>
            </div>

            <div className="mt-3 flex items-center gap-2 md:mt-0 md:items-end md:justify-end md:space-x-4">
              <Button
                variant="outline"
                onClick={handleOpenSettings}
                data-testid="team-settings-button"
              >
                {t('Team.settings')}
              </Button>
              <Button
                data-testid="team-add-member-button"
                disabled={!authorization?.canInviteTeamMember}
                onClick={() => handleMemberModal()}
              >
                {t('Team.add-member')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
